import axios from 'axios';
import { message } from 'antd';

const api = axios.create({
  baseURL: '/api',
  timeout: 30000
});

// 请求拦截器
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 响应拦截器
api.interceptors.response.use(
  response => {
    // blob 响应直接返回
    if (response.config.responseType === 'blob') {
      return response.data;
    }
    return response.data;
  },
  error => {
    if (error.response) {
      const { status, data, config } = error.response;
      if (status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(error);
      }
      // blob 错误响应需要读取文本
      if (config.responseType === 'blob' && data instanceof Blob) {
        data.text().then(text => {
          try {
            const json = JSON.parse(text);
            message.error(json.message || '请求失败');
          } catch {
            message.error('请求失败');
          }
        });
      } else {
        message.error(data.message || '请求失败');
      }
    } else {
      message.error('网络错误');
    }
    return Promise.reject(error);
  }
);

export default api;
